import { createActionCreator } from "common/ReduxUtils";
import { StorageInboundCreateActionTypes } from "../StorageInboundCreateAction.types";

export const setStorageInboundShippingPlanId = createActionCreator<number>(
  StorageInboundCreateActionTypes.SET_STORAGE_INBOUND_SHIPPING_PLAN_ID,
  "shippingPlanId"
);
